<template>
  <v-card flat color="grey lighten-3" class="main-card py-2">
    <v-row align="center" justify="space-around" class="pt-4 pb-2">
      <v-avatar size="200px">
        <img v-if="avatarSrc" :src="avatarSrc" />
        <v-icon v-else v-text="placeholder"></v-icon>
      </v-avatar>
    </v-row>
    <v-card-actions class="align-center justify-space-around">
      <v-btn text class="default" @click="modal = true">
        {{ title }}
      </v-btn>
    </v-card-actions>
    <avatar-modal
      v-if="modal"
      :title="title"
      :previous="avatarSrc"
      :dismiss="
        () => {
          modal = false
        }
      "
      :uploadAvatar="onNewAvatar"
    />
  </v-card>
</template>

<script>
import AvatarModal from './AvatarModal'

export default {
  name: 'AvatarWidget',
  components: {
    AvatarModal
  },
  data: () => ({
    modal: false
  }),
  props: {
    avatarSrc: String,
    placeholder: { type: String, required: true },
    onUpdate: { type: Function, required: true },
    logo: { type: Boolean, default: false }
  },
  computed: {
    title() {
      return this.logo ? this.$t('changeLogo') : this.$t('changeAvatar')
    }
  },
  methods: {
    onNewAvatar(payload) {
      this.onUpdate(payload)
        .then(() => {
          this.modal = false
        })
        .catch(() => {})
    }
  }
}
</script>

<i18n>
{
  "en": {
    "changeAvatar": "@:labels.changeAvatar",
    "changeLogo": "@:labels.changeLogo",
    "edit": "@:labels.edit"
  },
  "fr": {
    "changeLogo": "@:labels.changeLogo",
    "changeAvatar": "@:labels.changeAvatar",
    "edit": "@:labels.edit"
  }
}
</i18n>
